import { render, staticRenderFns } from "./MyChallenges.vue?vue&type=template&id=07973f53&scoped=true&"
import script from "./MyChallenges.vue?vue&type=script&lang=js&"
export * from "./MyChallenges.vue?vue&type=script&lang=js&"
import style0 from "./MyChallenges.vue?vue&type=style&index=0&id=07973f53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07973f53",
  null
  
)

export default component.exports